import type ScoringExplainRepository from "@/core/customers/repositories/ScoringExplainRepository";
import type { ScoringExplain } from "@/core/customers/entities/ScoringExplain";
import { RepositoryResult } from "@/core/shared/types/RepositoryResult";
import { HttpClient } from "../../http/HttpClient";
import { ApiResponse } from "../../api/types/ApiResponse";
import { executeRequest } from "../../http/services/executeRequest/executeRequest";
import scoringEndpoints from "../../api/scoringEndpoints/scoringEndpoints";
import { type ScoringExplainDto, mapScoringExplainDto } from "./mappers";

export default class ScoringExplainRepositoryBackend implements ScoringExplainRepository {
  constructor(private readonly httpClient: HttpClient) {}

  getExplain(
    businessKey: string,
  ): Promise<RepositoryResult<ScoringExplain | null>> {
    return executeRequest(
      () =>
        this.httpClient.get<ApiResponse<ScoringExplainDto | null>>({
          url: scoringEndpoints.explain(businessKey),
          withAuth: true,
        }),
      // Empty data = no scoring event yet (not an error).
      (dto) => (dto ? mapScoringExplainDto(dto) : null),
    );
  }
}
